import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const StyledAccordion = props=>{
    let {title, children} = props;
    return <Accordion sx={{backgroundColor: 'background.default'}}>
      <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
        <Typography component="span" fontWeight="bold">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {children}
      </AccordionDetails>
    </Accordion>;
};

export default StyledAccordion;
